// extracted by mini-css-extract-plugin
export default {"app_policy":"Cokie_app_policy__JhI7f"};